import { CodeSnippetExecState } from '@devbookhq/sdk'
import {
  Play as PlayIcon,
  Square as StopIcon,
} from 'lucide-react'
import {
  ReactNode,
  useEffect,
  useState,
} from 'react'

import Button from 'components/Button'
import SpinnerIcon from 'components/icons/Spinner'

import {
  CodeSnippetExtendedState,
  CodeSnippetState,
} from '@devbookhq/react'
import { analytics } from 'utils/analytics'

export interface Props {
  className?: string
  state: CodeSnippetState
  onRunClick: () => void
  onStopClick: () => void
}

interface UI {
  text: 'Loading...' | 'Run' | 'Stop' | 'Error'
  icon: ReactNode
}

const loadingUI: UI = {
  text: 'Loading...',
  icon: <SpinnerIcon />,
}

const stoppedUI: UI = {
  text: 'Run',
  icon: <PlayIcon size={14} />,
}

const runningUI: UI = {
  text: 'Stop',
  icon: <StopIcon size={14} />,
}

const failedUI: UI = {
  text: 'Error',
  icon: null,
}

function ExecutionButton({
  className,
  state,
  onRunClick,
  onStopClick,
}: Props) {
  const [ui, setUI] = useState<UI>(loadingUI)

  useEffect(function updateUI() {
    switch (state) {
    case CodeSnippetExecState.Stopped:
      setUI(stoppedUI)
      break
    case CodeSnippetExecState.Running:
      setUI(runningUI)
      break
    case CodeSnippetExtendedState.Loading:
      setUI(loadingUI)
      break
    case CodeSnippetExtendedState.Failed:
      setUI(failedUI)
      break
    }
  },
  [state],)

  function handleClick(e: any) {
    if (state === CodeSnippetExecState.Stopped) {
      // Make UI responsive by immediately it without waiting for server's response.
      setUI(runningUI)
      onRunClick()
    }

    if (state === CodeSnippetExecState.Running) {
      onStopClick()
      analytics.track('code executed stopped')
    }
  }

  return (
    <Button
      className={className}
      icon={ui.icon}
      text={ui.text}
      version={state === CodeSnippetExtendedState.Loading || state === CodeSnippetExtendedState.Failed ? Button.version.Disabled : Button.version.PrimaryGreen}
      onClick={handleClick}
    />
  )
}

export default ExecutionButton
